import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { MemberTeacherPage } from './member-teacher.page';
import { InputNilaiPage } from '../input-nilai/input-nilai.page';

const routes: Routes = [
  {
    path: '',
    component: MemberTeacherPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [MemberTeacherPage]  
})
export class MemberTeacherPageModule {}
